import { Inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'

// TODO: Refaktorovat na route konstanty (Angular standard way) a tuto service odstranit.
// Místo wrapper metod nad router.navigate() mít objekt s cestami (APP_ROUTES)
// a používat ho přímo v routerLink a Router.navigate().
@Injectable({
    providedIn: 'root'
})
export class CaStateService {

    constructor(
        @Inject(Router) private router: Router
    ) {
    }

    // ---
    // NOTE: reloadState() removed - use location.reload() if needed or refactor to use NgRx

    // ---
    // NOTE: isState() methods removed - use router.url comparison if needed

    // ---

    isContractListState(): boolean {
        return this.router.url.startsWith('/contracts/list')
    }

    isPaymentsState(): boolean {
        return this.router.url.startsWith('/payments')
    }

    // ---

    setAdminUserListState(): void {
        this.router.navigate(['/admin/user/list'])
    }

    setBarterCreateState(params?): void {
        this.router.navigate(['/barter/create'], { queryParams: params || {} })
    }

    setBarterEditState(barterId: number, params?): void {
        this.router.navigate(['/barter/edit', barterId], { queryParams: params || {} })
    }

    setBarterListState(params?): void {
        this.router.navigate(['/barter/list'], { queryParams: params || {} })
    }

    setBarterShowState(barterId: number): void {
        this.router.navigate(['/barter/show', barterId])
    }

    setContractListState(params?): void {
        this.router.navigate(['/contracts/list'], { queryParams: params || {} })
    }

    setContractCreateState(params?): void {
        this.router.navigate(['/contracts/create'], { queryParams: params || {} })
    }

    setContractEditState(id: number, params?): void {
        this.router.navigate(['/contracts/edit', id], { queryParams: params || {} })
    }

    setContractShowState(id: number): void {
        this.router.navigate(['/contracts/show', id])
    }

    setContractGroupShowState(groupId: number): void {
        this.router.navigate(['/group/contractGroup/show', groupId])
    }

    setCustomerEditState(id: number): void {
        this.router.navigate(['/admin/customer/edit', id])
    }

    setDepartmentListState(): void {
        this.router.navigate(['/group/department/list'])
    }

    setMapState(params?): void {
        this.router.navigate(['/map'], { queryParams: params || {} })
    }

    setProjectListState(): void {
        this.router.navigate(['/admin/project/list'])
    }

    setParcelsEditState(id: number, params?): void {
        this.router.navigate(['/parcels/edit', id], { queryParams: params || {} })
    }

    setParcelGroupShowState(groupId: number): void {
        this.router.navigate(['/group/parcelGroup/show', groupId])
    }

    setParcelsListState(params?): void {
        this.router.navigate(['/parcels/list'], { queryParams: params || {} })
    }

    setParcelShowState(id: number, params?): void {
        this.router.navigate(['/parcels/show', id], { queryParams: params || {} })
    }

    setBuildingShowState(id: number, params?): void {
        this.router.navigate(['/buildings/show', id], { queryParams: params || {} })
    }

    setBuildingsListState(params?): void {
        this.router.navigate(['/buildings/list'], { queryParams: params || {} })
    }

    setPurchaseCaseEditState(id: number): void {
        this.router.navigate(['/purchase/edit', id])
    }

    setPurchaseCaseListState(): void {
        this.router.navigate(['/purchase'])
    }

    setPurchaseCaseViewState(id: number): void {
        this.router.navigate(['/purchase/view', id])
    }

    setLandingPageState(): void {
        this.router.navigate(['/landingPage'])
    }

    setLoginState(params?): void {
        this.router.navigate(['/login'], { queryParams: params || {} })
    }

    setLvShowState(id: number, katuzeKod: string, distinctChar: string, params?): void {
        this.router.navigate(['/nonCadastral/lv/show', id], { queryParams: { ...params, katuzeKod, distinctChar } })
    }

    setLvListState(): void {
        this.router.navigate(['/nonCadastral/lv/list'])
    }

    setAdminSigniWorkspaceEditState(id: number): void {
        this.router.navigate(['/admin/signiWorkspace/edit', id])
    }

    setNonCadastralContractCreateState(): void {
        this.router.navigate(['/nonCadastral/nonCadastralContract/create'])
    }

    setNonCadastralContractShowState(id: number): void {
        this.router.navigate(['/nonCadastral/nonCadastralContract/edit', id])
    }

    setNonCadastralContractListState(): void {
        this.router.navigate(['/nonCadastral/nonCadastralContract/list'])
    }

    setPaymentsState(): void {
        this.router.navigate(['/payments'])
    }

    setSpreaderListState(): void {
        this.router.navigate(['/admin/codelist/spreader'])
    }

    setSubcontractCreateState(params?): void {
        const queryParams = params || {}
        this.router.navigate(['/subcontract/create'], { queryParams })
    }

    setSubcontractEditState(id: any, params?): void {
        const queryParams = params || {}
        this.router.navigate(['/subcontract/edit', id], { queryParams })
    }

    setSubcontractShowState(id: number): void {
        this.router.navigate(['/subcontract/show', id])
    }

    setSubcontractListState(params?): void {
        this.router.navigate(['/subcontract/list'], { queryParams: params || {} })
    }

    setSubjectShowCreate(createRepresentativeTo?: any): void {
        const queryParams = createRepresentativeTo ? { createRepresentativeTo } : {}
        this.router.navigate(['/subjects/create'], { queryParams })
    }

    setSubjectListState(params?): void {
        this.router.navigate(['/subjects/list'], { queryParams: params || {} })
    }

    setSubjectShowState(subjectId: number, params?): void {
        this.router.navigate(['/subjects/show', subjectId], { queryParams: params || {} })
    }

    setTemplateDocumentEditState(templateId: number): void {
        this.router.navigate(['/template/documents/edit', templateId])
    }

    setTemplateParamEdit(templateId: number): void {
        this.router.navigate(['/template/params/edit', templateId])
    }

    setAdminState(): void {
        this.router.navigate(['/admin'])
    }

    setBulkOperationState(): void {
        this.router.navigate(['/bulkOperation'])
    }

    setCadastralDataState(): void {
        this.router.navigate(['/cadastralData'])
    }

    setGroupState(): void {
        this.router.navigate(['/group'])
    }

    setStatisticsState(): void {
        this.router.navigate(['/statistics'])
    }

    setTaxesState(): void {
        this.router.navigate(['/taxes'])
    }

    setTemplateListState(): void {
        this.router.navigate(['/template'])
    }

    setTriggerProcessState(): void {
        this.router.navigate(['/admin/trigger-process'])
    }
}